import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// ============================================================================
// Rendelés üzenőfal — DTO-k a 23-logic.js messages state-jéből levezetve
// (04-uzenofal-panel.html).
// ============================================================================

export interface OrderMessage {
  id: number;
  orderId: number;
  /** üzenetíró user neve */
  author: string;
  text: string;
  /** ISO dátum */
  createdAt: string;
  /** true, ha a bejelentkezett user írta (ő törölheti) */
  own: boolean;
}

@Injectable({ providedIn: 'root' })
export class OrderMessagesService {

  constructor(private http: HttpClient) {}

  /** GET orders/:id/messages */
  getMessages(orderId: number): Observable<OrderMessage[]> {
    return this.http.get<OrderMessage[]>(`orders/${orderId}/messages`);
  }

  /** POST orders/:id/messages */
  sendMessage(orderId: number, text: string): Observable<OrderMessage> {
    return this.http.post<OrderMessage>(`orders/${orderId}/messages`, { text });
  }

  /** DELETE orders/:id/messages/:messageId */
  deleteMessage(orderId: number, messageId: number): Observable<void> {
    return this.http.delete<void>(`orders/${orderId}/messages/${messageId}`);
  }
}
